import * as Sentry from '@sentry/vue';
import { replayIntegration } from '@sentry/vue';
import { App } from 'vue';
import {
    SENTRY_ATTACH_STACKTRACE,
    SENTRY_DSN,
    SENTRY_ENABLED,
    SENTRY_ENVIRONMENT,
    SENTRY_PROFILES_SAMPLE_RATE,
    SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
    SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    SENTRY_TRACES_SAMPLE_RATE,
} from '../../config/sentry';
import { inertiaRoutingInstrumentation } from '../../lib/inertia-router-sentry-instrumentation';

export function initializeSentry(app: App) {
    Sentry.init({
        app,
        dsn: SENTRY_DSN,
        tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
        profilesSampleRate: SENTRY_PROFILES_SAMPLE_RATE,
        replaysSessionSampleRate: SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        integrations: [inertiaRoutingInstrumentation(), replayIntegration()],
        // Enable error tracking
        enabled: SENTRY_ENABLED,
        // Set environment
        environment: SENTRY_ENVIRONMENT,
        // Capture unhandled rejections
        attachStacktrace: SENTRY_ATTACH_STACKTRACE,
    });
}
